import React, { ReactElement, useEffect } from 'react';
import { graphql } from 'gatsby';
import { Component } from '../components/Contentful/component';
import { PrivateRoute } from '../components/Utils/privateRoute';
import { MainLayout } from '../components/UI/Layout/Main/mainLayout';
import { SiteMap } from '../components/Marketing/Seo';
import { formatContentfulComponentProps } from '../utils/globals';

export default ({ data, pageContext }): ReactElement => {
  const page = data?.contentfulPage;

  const { allLocalSlugs, node_locale } = pageContext;

  const isValidLocal = (node) =>
    node.node_locale === node_locale ||
    (node_locale.includes('en') && node.node_locale === 'en');

  const blogPages = data?.allContentfulBlogArticle?.nodes.filter((p) =>
    isValidLocal(p)
  );

  const categories = data?.allContentfulProductCategory?.nodes.filter((p) =>
    isValidLocal(p)
  );

  const app = data.allContentfulApp?.nodes.filter((p) => isValidLocal(p));

  const {
    isPrivate,
    components,
    layout,
    popup,
    seoMetadata,
    slug,
    title,
    type,
    canonical,
    robots,
  } = page;

  return (
    <MainLayout
      {...layout}
      page={{
        seoMetadata,
        slug,
        type,
        title,
        canonical,
        robots,
        allLocalSlugs,
      }}
      popup={popup}>
      <SiteMap
        {...formatContentfulComponentProps(components[0])}
        categories={categories}
        blogPages={blogPages}
        pages={app[0]?.pages}
      />
    </MainLayout>
  );
};

export const pageQuery = graphql`
  query SitemapPageById($id: String!) {
    contentfulPage(id: { eq: $id }) {
      ...PageData
    }
    allContentfulBlogArticle {
      nodes {
        title
        node_locale
        id
        slug {
          url
        }
      }
    }
    allContentfulProductCategory {
      nodes {
        title
        node_locale
        pageReference {
          robots
          slug {
            url
          }
        }
        products {
          ... on ContentfulProduct {
            id
            pageReference {
              id
              node_locale
              slug {
                url
              }
              type
              title
              robots
              createRedirects
            }
          }
          ... on ContentfulProductPack {
            id
            pageReference {
              id
              node_locale
              slug {
                url
              }
              type
              title
              robots
              createRedirects
            }
          }
        }
      }
    }
    allContentfulApp(filter: { title: { eq: "b2c" } }) {
      nodes {
        node_locale
        pages {
          id
          node_locale
          slug {
            url
          }
          label {
            text
          }
          title
          robots
        }
      }
    }
  }
`;
